import styled from '@emotion/styled';

import { withConfig } from 'src/withConfig';



export const EventRowItem = withConfig(theme => styled('div', { label: 'EventRowItem' })`

    align-items: center;

    display: flex;

    gap: 8px;

    min-width: 0;

    position: relative;

    width: 50%;

    &:last-of-type {

        &::before {

            align-items: center;

            bottom: 0;

            content: 'v';

            display: flex;

            flex: 0 0 16px;

            font-size: ${theme.star.eventRow.typography.fontSizePrimary};

            font-weight: ${theme.star.eventRow.typography.fontWeightSecondary};

            justify-content: center;

            line-height: ${theme.star.eventRow.typography.lineHeightPrimary};

            margin: auto 8px;

            position: absolute;

            right: 100%;

            top: 0;

            width: 16px;

        }

    }

    &:first-of-type {

        flex-direction: row-reverse;

        &::before {

            content: none;

        }

    }

    @media ${theme.star.mediaQuery.desktop} {

        width: auto;

        &:first-of-type {

            flex-direction: row;

        }

        &:last-of-type {

            &::before {

                content: none;

            }

        }

    }

`);



export const EventRowItemLogo = withConfig(theme => styled('img', { label: 'EventRowItemLogo' })`

    display: block;

    height: 48px;

    width: 48px;

    @media ${theme.star.mediaQuery.desktop} {

        height: 32px;

        width: 32px;

    }

`);



interface EventRowParticipantNamePropsType {

    isHomeParticipant: boolean;

}



export const EventRowParticipantName = withConfig(theme => styled('div', { label: 'EventRowParticipantName' })<EventRowParticipantNamePropsType>`

    color: ${theme.star.eventRow.txtColor};

    font-size: ${theme.star.eventRow.typography.fontSizePrimary};

    font-weight: ${theme.star.eventRow.typography.fontWeightPrimary};

    line-height: ${theme.star.eventRow.typography.lineHeightPrimary};

    overflow: hidden;

    position: relative;

    text-align: ${({ isHomeParticipant }): string => isHomeParticipant ? 'right' : 'left'};

    text-overflow: ellipsis;

    white-space: nowrap;

`);

